import { useHash } from "@/hooks/useHash";
import { cn } from "@/lib/utils";
import { Fragment, useEffect, useState } from "react";

const MicrositeFocus = ({ isActive, position }) => {
  return (
    <Fragment>
      <div
        className={cn(
          "top-0 right-0 bottom-0 left-0 z-50 absolute transition-all pointer-events-none",
          isActive ? "opacity-90" : "opacity-0"
        )}
      >
        <div
          className="top-0 left-0 z-40 absolute bg-black w-full"
          style={{
            height: `${position.top}px`,
          }}
        />

        <div
          className="left-0 z-40 absolute bg-black w-full"
          style={{
            top: `${position.top + position.height}px`,
            height: `${
              position.docHeight - (position.top + position.height)
            }px`,
          }}
        />

        <div
          className="left-0 z-40 absolute bg-black w-full"
          style={{
            top: 0,
            left: 0,
            width: `${position.left}px`,
            height: `${position.docHeight}px`,
          }}
        />

        <div
          className="left-0 z-40 absolute bg-black w-full"
          style={{
            top: 0,
            left: `${position.left + position.width}px`,
            width: `${position.left}px`,
            height: `${position.docHeight}px`,
          }}
        />
      </div>

      {/* <div
        className={cn("z-50 absolute pointer-events-none")}
        style={{
          top: `${pos.top}px`,
          left: `${pos.left}px`,
          width: `${pos.width}px`,
          height: `${pos.height}px`,
        }}
      /> */}
    </Fragment>
  );
};

export const useMicrositeFocus = ({ data }) => {
  const hash = useHash();

  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    docHeight: 0,
  });

  const [focusId, setFocusId] = useState("");
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const fragment = hash.split("#")[1];
    const padding = 10;

    if (fragment) {
      if (fragment.startsWith("f_")) {
        const targetId = fragment.replace("f_", "");
        const theId = `mcomp-${targetId}`;
        setTimeout(() => {
          const comp = data.components.find((m) => m._id === targetId);
          if (comp) {
            setFocusId(targetId);
            const targetDoc = window.document.getElementById(theId);
            if (targetDoc) {
              const rect = targetDoc.getBoundingClientRect();
              const top = rect.top + window.scrollY;
              const left = rect.left + window.scrollX;
              setPosition({
                top: top - padding,
                left: left - padding,
                width: rect.width + padding * 2,
                height: rect.height + padding * 2,
                docHeight: document.body.scrollHeight,
              });
              setTimeout(() => {
                //@ts-ignore
                targetDoc?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }, 200);
            }
            setIsActive(true);
            setTimeout(() => {
              setIsActive(false);
            }, 1500);
          }
        }, 200);
      }
    }
  }, [hash]);

  return { isActive, position, focusId };
};

export default MicrositeFocus;
